import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-light-container backdrop-blur-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "modal-light-body" }, [
          _createElementVNode("div", { class: "modal-light-card" }, [
            _createElementVNode("div", { class: "modal-light-spinner" })
          ])
        ], -1)
      ]))]))
    : _createCommentVNode("", true)
}